import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { externalSupabase } from "@/lib/externalSupabase";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase will pick up the token from the URL hash automatically
    externalSupabase.auth.getSession().then(({ data: { session } }) => {
      // Redirect to dashboard whether or not session exists yet
      // (onAuthStateChange in Dashboard will handle the rest)
      navigate("/dashboard", { replace: true });
    });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
    </div>
  );
};

export default AuthCallback;
